import { render, staticRenderFns } from "./ProductsByCategoriesSection.vue?vue&type=template&id=02cc616c&scoped=true&"
import script from "./ProductsByCategoriesSection.vue?vue&type=script&lang=js&"
export * from "./ProductsByCategoriesSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsByCategoriesSection.vue?vue&type=style&index=0&id=02cc616c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc616c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
